import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { classNames } from 'primereact/utils';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

const AppPage = (props: {
  className?: string;
  title: string;
  breadcrumbs?: string | BreadcrumbItem[];
  headerEnd?: ReactNode;
  children: ReactNode;
}): JSX.Element => {
  const { className, title, breadcrumbs, headerEnd, children } = props;

  const renderBreadcrumbs = () => {
    if (!breadcrumbs) return null;

    if (typeof breadcrumbs === 'string') {
      return <div className="text-gray-400 text-[0.8rem] pt-1">{breadcrumbs}</div>;
    }

    return (
      <div className="flex items-center gap-1.5 text-[0.8rem] pt-1">
        {breadcrumbs.map((crumb, idx) => (
          <span key={idx} className="flex items-center gap-1.5">
            {idx > 0 && <i className="pi pi-chevron-right text-gray-300" style={{ fontSize: '0.55rem' }} />}
            {crumb.to ? (
              <Link to={crumb.to} className="text-[#2571ab] hover:text-[#1e6196] transition-colors no-underline">
                {crumb.label}
              </Link>
            ) : (
              <span className="text-gray-400">{crumb.label}</span>
            )}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className={classNames('flex flex-col grow px-6 py-5', className)}>
      <div className="flex align-items-center mb-5">
        <div className="flex-grow">
          <div className="font-semibold text-gray-800 text-[1.4rem] tracking-[-0.01em]">{title}</div>
          {renderBreadcrumbs()}
        </div>
        <div>{headerEnd}</div>
      </div>
      <div className="min-w-0 overflow-hidden">{children}</div>
    </div>
  );
};

export default AppPage;
